import React, { HTMLAttributes } from 'react';
import styled from 'styled-components';

interface OwnProps {
  title: string,
  className?: string,
  style?: {}
}

const FildSetContainer = styled.fieldset`
  border: 1px solid #efefef;
  margin-bottom: 14px;
  align-items: center;
  width: 500px;
  padding: 30px;
  border-radius: 3px;
`;

type Props = OwnProps & HTMLAttributes<HTMLFieldSetElement>

const BoxContainer: React.FC<Props> = (props: Props) => {
  const { children, title } = props;
  return (
    <FildSetContainer {...props}>
      {
        (title !== '' &&
          <legend style={{ fontSize: '14px' }}>
            {title}
          </legend>
        )
      }
      {children}
    </FildSetContainer>
  );
};

export { BoxContainer };